import { render, staticRenderFns } from "./CancelReasonList.vue?vue&type=template&id=0a493e57"
import script from "./CancelReasonList.js?vue&type=script&lang=js&external"
export * from "./CancelReasonList.js?vue&type=script&lang=js&external"
import style0 from "./CancelReasonList.vue?vue&type=style&index=0&id=0a493e57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports